import { render, staticRenderFns } from "./PersonUpsertProvider.vue?vue&type=template&id=4983b7aa&scoped=true&"
import script from "./PersonUpsertProvider.vue?vue&type=script&lang=ts&"
export * from "./PersonUpsertProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4983b7aa",
  null
  
)

export default component.exports